import React from "react";
import AdminLogin from "./AdminLogin";
import AdminDashboard from "./AdminDashboard";
import { adminMe, getToken, clearToken } from "./adminApi";

export default function AdminApp() {
  const [authed, setAuthed] = React.useState(null); // null=checking
  const [username, setUsername] = React.useState("admin");

  // Keep the private admin area out of search indexes (defence in depth
  // alongside robots.txt and the auth-protected API).
  React.useEffect(() => {
    const prevTitle = document.title;
    document.title = "NUMEX Admin";
    let meta = document.head.querySelector('meta[name="robots"]');
    const created = !meta;
    const prevContent = meta ? meta.getAttribute("content") : null;
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "robots");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", "noindex, nofollow");
    return () => {
      document.title = prevTitle;
      if (created) {
        meta.remove();
      } else if (prevContent !== null) {
        meta.setAttribute("content", prevContent);
      }
    };
  }, []);

  const check = React.useCallback(() => {
    if (!getToken()) {
      setAuthed(false);
      return;
    }
    adminMe()
      .then((d) => {
        setUsername(d.username || "admin");
        setAuthed(true);
      })
      .catch(() => {
        clearToken();
        setAuthed(false);
      });
  }, []);

  React.useEffect(() => {
    check();
  }, [check]);

  if (authed === null) {
    return (
      <div className="min-h-[100dvh] flex items-center justify-center bg-[#faf9f6] text-[#75756f]">
        Loading…
      </div>
    );
  }

  return authed ? (
    <AdminDashboard username={username} onLogout={() => setAuthed(false)} />
  ) : (
    <AdminLogin onAuthed={check} />
  );
}
